module.exports = __webpack_public_path__ + "img/31.ec2a2472.jpg";